import React from "react";
import CompanyFormModal, { CompanyFormModalProps } from "./CompanyFormModal";
import Resources from "../../types/Resources";
import useCreateCompanyModal from "./useCreateCompanyModal";

export type CreateCompanyModalProps = {
    show: boolean;
    resources: Resources;
    canManageIsEnergyHarbourCustomer: boolean;
    onHide: () => void;
    onCompanyCreated: (createdCompanyId: string) => void;
} 

function CreateCompanyModal(props: CreateCompanyModalProps) {
    const modalContent = useCreateCompanyModal(props);

    return (
        <CompanyFormModal
            show={props.show}
            onHide={props.onHide}
            resources={props.resources}
            canManageIsEnergyHarbourCustomer={props.canManageIsEnergyHarbourCustomer}
            modalHeader={props.resources.get("NewCompany") ?? ""}
            formState={modalContent.formState}
            onIsEnergyHarbourCustomerChange={modalContent.handleIsEnergyHarbourCustomerChange}
            onNameChange={modalContent.handleNameChange}
            onSubmit={modalContent.handleSubmitAsync}
            disableSubmit={modalContent.disableSubmit}
            isLoading={false}
        />
    );
}

export default CreateCompanyModal;
